import { FETCH_PRODUCT_METADATA_AND_DIRECTORS } from "lib/graphql"
import { BONUS_ARCHIVES, BONUS_EXCLUSIFS } from "lib/tools/product"

import { Query, Bonuses } from "components/common"
import { CreditsDatasheet } from "components/film/credits-datasheet"
import { Header, Recommenders, Sheet, Others } from "components/subscription/film"


export const Content = ({ product, details, loading }) => (
	<>
		<Header
			product={product}
			loading={loading}
		/>
		<div className="film-extras">
			<Recommenders
				product={product}
				loading={loading}
			/>
			<Sheet
				product={product}
				details={details}
				loading={loading}
			/>
			<CreditsDatasheet
				product={product}
				details={details}
				loading={loading}
			/>
			<Bonuses
				product={product}
				productId={product.id}
				type={BONUS_EXCLUSIFS}
			/>
			<Bonuses
				product={product}
				productId={product.id}
				type={BONUS_ARCHIVES}
			/>
			<Others product={product} />
		</div>
	</>
)

export const FilmOverlay = ({ product }) => (
	<Query
		query={FETCH_PRODUCT_METADATA_AND_DIRECTORS}
		options={{ variables: { id: product.id } }}
		renderLoading={() => (
			<Content product={product} loading={true} />
		)}
	>
		{({ cms: { products: { items: [details] } } }) => (
			<Content product={product} details={details} />
		)}
	</Query>
)
